import { render } from "./MProgress.vue?vue&type=template&id=3bea5072&scoped=true"
import script from "./MProgress.vue?vue&type=script&lang=js"
export * from "./MProgress.vue?vue&type=script&lang=js"

import "./MProgress.vue?vue&type=style&index=0&id=3bea5072&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bea5072"]])

export default __exports__